import { PageLayout } from 'components/base/layout-components';
import {
  StyledDescription,
  StyledHeader,
  StyledInvalidEmptyStateImg,
  StyledInvalidFilterSet
} from './InvalidFilterSet.style';
import InvalidFilterSetImg from './invalid-filter-set.svg';
import { StyledLink } from 'components/base/common-styles';
import { useHistory } from 'react-router';

const InvalidFilterSet = () => {
  const history = useHistory();
  const from = history.location.state?.from;
  const moduleName = from?.moduleName;

  const goBackToContext = e => {
    e.preventDefault();
    history.replace(from.url);
  };

  return (
    <PageLayout>
      <StyledInvalidFilterSet>
        <StyledInvalidEmptyStateImg src={InvalidFilterSetImg} alt='' />
        <StyledHeader>
          The project shared with you is inaccessible <br />
        </StyledHeader>
        <StyledDescription>
          Contact the owner for access {''}
          {moduleName && (
            <>
              or proceed to {''}
              <StyledLink href='###' onClick={goBackToContext}>
                {from.moduleName}
              </StyledLink>
            </>
          )}
        </StyledDescription>
      </StyledInvalidFilterSet>
    </PageLayout>
  );
};

export default InvalidFilterSet;
